<script>
import axios from 'axios'
import AuthCard from '@components/auth-card'

export default {
  page() {
    return {
      title: `${this.property.name} - Web Checkin`,
      meta: [{ name: 'description', content: 'Much easier with web-checkin' }],
    }
  },

  components: { AuthCard },

  props: {
    property: { type: Object, required: true },
    alert: { type: String, default: '' },
  },

  data() {
    return {
      form: {
        bookingId: '',
        lastName: '',
      },
      tryingToCheck: false,
      errorMessage: '',
    }
  },

  methods: {
    checkReservation() {
      this.tryingToCheck = true
      this.errorMessage = ''

      axios
        .post('/api/v2/check-reservation', {
          ...this.form,
          property: this.property.id,
        })
        .then(() => {
          this.tryingToCheck = false
          this.errorMessage = 'You have been check-in.'
        })
        .catch((err) => {
          this.tryingToCheck = false

          if (err.response.status === 422) {
            this.errorMessage =
              'Please enter valid Booking/Hotel confirmation ID or last name.'
            return
          }

          this.$router.push({
            name: 'web-checkin-details',
            query: this.form,
          })
        })
    },
  },
}
</script>

<template>
  <AuthCard heading="Web Check-in" :alert="alert">
    <ValidationObserver v-slot="{ invalid, passes }" slim>
      <form @submit.prevent="passes(checkReservation)">
        <BaseInput v-model="form.lastName" label="Last name" rules="required" />

        <BaseInput
          v-model="form.bookingId"
          label="Booking ID / Hotel confirmation ID"
          rules="required|numeric"
        />

        <p v-if="errorMessage" class="text-sm text-red-500 italic px-3 mb-4">{{
          errorMessage
        }}</p>

        <div class="w-full flex justify-end px-3">
          <button
            type="submit"
            class="btn btn-gold"
            :class="{ 'btn-disabled': invalid || tryingToCheck }"
            :disabled="invalid || tryingToCheck"
          >
            <i v-if="tryingToCheck" class="fas fa-circle-notch fa-spin"></i>
            <span v-else>Find my booking</span>
          </button>
        </div>
      </form>
    </ValidationObserver>
  </AuthCard>
</template>
